<template>
  <main class="u-container">
    <h1
      id="official-header"
      class="font-bold"
      :class="{'text-4xl': !desktopView}"
    >
      USPS Change-of-Address<sup>®</sup>
    </h1>
    <IndividualProgressBarWithSteps
      v-if="!desktopView && isChoiceFlow"
      :mobile="true"
    />

    <IndividualProgressBarWithSteps
      v-if="desktopView && !showChoiceExperience"
      :mobile="false"
    />

    <IndividualProgressBar
      v-if="desktopView && showChoiceExperience"
      id="individual-progress-bar"
      role="progressbar"
      :aria-valuenow="progressStep"
      :aria-valuemin="current"
      :aria-valuemax="1"
    />
    <ProgressBar
      v-if="!desktopView && !isChoiceFlow"
      :steps="6"
      :current="3"
    />
    <h2
      id="step-heading"
      ref="stepHeading"
      :class="{
        'mt-8': desktopView, 'text-xl': !desktopView, 'mt-6': !desktopView
      }"
    >
      <span
        v-if="!isChoiceFlow && !desktopView"
      >Step 2:</span><span class="font-bold"> Verify your information</span>
    </h2>
    <div
      :class="{ 'mt-4': desktopView, 'mt-6': !desktopView, 'text-s': !desktopView }"
    >
      <p>
        <span
          id="data-mutated-heading"
          class="font-bold"
        >
          {{ showMutatedMessage ?
            "Why your name and address might look different than how you entered them:" : '' }}
        </span>
        <span id="data-mutated-paragraph">
          {{ showMutatedMessage ?
            `special characters in your name (like apostrophes) may have been removed
          and your address(es) may have been standardized to match the official
          U.S. Postal Service format. This helps forward your mail more
          effectively.` : '' }}
        </span>
      </p>
      <p
        id="data-mutated-edit-copy"
        class="mt-4"
      >
        {{ desktopView ? `If you need to make any changes to the information below,
        click the Edit button and save your changes.` : '' }}
      </p>
    </div>
    <router-view />
  </main>
</template>

<script>
import {
  IndividualProgressBar,
  IndividualProgressBarWithSteps,
  ProgressBar,
} from '@mgo/ui/lib/components';
import { isDesktop } from '../../utils/deviceType';
// we need to prescreen for extensions and informedDeliveryEligible

export default {
  name: 'VerifyInfo',
  components: { IndividualProgressBarWithSteps, IndividualProgressBar, ProgressBar },
  data: () => ({
    desktopView: isDesktop(),
  }),
  computed: {
    showSimplifyExperience: () => JSON.parse(sessionStorage.getItem('showSimplifyExperience') ?? false),
    showMutatedMessage() {
      if (this.desktopView) return true;
      return !this.desktopView && this.isChoiceFlow;
    },
    showExperienceA: () => JSON.parse(sessionStorage.getItem('showExperienceA')),
    showExperienceB: () => JSON.parse(sessionStorage.getItem('showExperienceB')),
    current() {
      if (!this.showChoiceExperience && this.desktopView) return 2;
      if (!this.showChoiceExperience && !this.desktopView) return 2;
      if (this.showChoiceExperience && this.desktopView) return 3;
      return 4;
    },
    totalSteps() {
      if (!this.showChoiceExperience && this.desktopView) return 5;
      if (!this.showChoiceExperience && !this.desktopView) return 5;
      if (this.showChoiceExperience && this.desktopView) return 7;
      return 8;
    },
    progressStep() {
      return this.current / this.totalSteps;
    },
    showChoiceExperience: () => JSON.parse(sessionStorage.getItem('showChoiceExperience')),
    showNonControlExperience() {
      return JSON.parse(sessionStorage.getItem('showNonControlExperience'));
    },
    isChoiceFlow() {
      return this.showChoiceExperience || this.showNonControlExperience;
    },

  },
};
</script>
